export const CREATE_NEW_POST = "USER@CREATE_NEW_POST";
export const CREATE_NEW_POST_INIT = "USER@CREATE_NEW_POST_INIT";
export const CREATE_NEW_POST_SUCCESS = "USER@CREATE_NEW_POST_SUCCESS";
export const CREATE_NEW_POST_FAILED = "USER@CREATE_NEW_POST_FAILED";

export const GET_POST_DETAILS = "USER@GET_POST_DETAILS";
export const GET_POST_DETAILS_INIT = "USER@GET_POST_DETAILS_INIT";
export const GET_POST_DETAILS_SUCCESS = "USER@GET_POST_DETAILS_SUCCESS";
export const GET_POST_DETAILS_FAILED = "USER@GET_POST_DETAILS_FAILED";

export const UPDATE_POST = "USER@UPDATE_POST";
export const UPDATE_POST_INIT = "USER@UPDATE_POST_INIT";
export const UPDATE_POST_SUCCESS = "USER@UPDATE_POST_SUCCESS";
export const UPDATE_POST_FAILED = "USER@UPDATE_POST_FAILED";
